export const LANG_LABELS = {
  'pt-br': 'Português',
  en: 'Inglês',
  es: 'Espanhol'
}
